<template>
  <div id="gameCanvasWrapper">
    <div class="speed">加速<span @click="speedUp(1)">1x</span><span @click="speedUp(2)">2x</span><span @click="speedUp(4)">4x</span></div>
    <div id="gameCanvas" ></div>
  </div>
</template>

<script>
export default {
  name: 'codeaha25d-scratch-container',
  props: {
    editor: Object,
    workspace: Object,
    aha_lv_id: {
      type: Number,
      default: 1
    },
    aha_lang: {
      type: String,
      default: 'zh_CN'
    },
    aha_app: {
      type: Number,
      default: 2
    },
    aha_speed: {
      type: Number,
      default: 1
    },
    aha_code_lang: {
      type: String,
      default: 'python'
    },
    aha_game_width: {
      type: Number,
      default: 500
    },
    aha_hero_type: {
      type: String,
      default: 'hero'
    },
    aha_lv_debug: {
      type: Boolean,
      default: false
    },
    aha_sound_on: {
      type: Boolean,
      default: false
    },
    aha_popup_on: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      aetherOptions: {
        language: 'python',
        executionLimit: 50000
      },
      ahaConfig: {
        aha_lv_id: 'lab_depot_' + this.$g.aha_padding(this.aha_lv_id, 3),
        aha_lang: this.aha_lang,
        aha_app: this.aha_app,
        aha_speed: this.aha_speed,
        aha_code_lang: this.aha_code_lang,
        aha_game_width: this.aha_game_width,
        aha_hero_type: this.aha_hero_type,
        aha_lv_debug: this.aha_lv_debug,
        aha_sound_on: this.aha_sound_on,
        aha_popup_on: this.aha_popup_on
      },
      aether: null
    }
  },
  beforeDestroy: function () {
    if (window['Cocos'] && window['Cocos']['cc'] && window['Cocos']['cc']['resetEngine']) window['Cocos']['cc']['resetEngine']()
  },
  mounted: function () {
    this.init()
  },
  methods: {
    speedUp (speed) {
      this.$set(this.ahaConfig, 'aha_speed', speed)
      // this.init()
      this.$emit('changeSpeed', speed)
    },
    init () {
      if (window['Cocos'] && window['Cocos']['cc'] && window['Cocos']['cc']['resetEngine']) window['Cocos']['cc']['resetEngine']()
      this.aether = new window['Aether'](this.aetherOptions)
      window['CodeahaManager'].initForScratchBlocks(this.ahaConfig, this.workspace, this.aether, alert)
      window['CodeahaManager'].initGame()
      setTimeout(() => {
        this.$emit('CodeahaManagerInitFinished')
      }, 800)
    }
  }
}
</script>

<style scoped lang="scss">
  #gameCanvas {
    /*position: absolute;*/
    /*top:0;*/
    /*right:0px;*/
    display: flex;
    justify-content: center;
    align-items: center;

    ::v-deep canvas:focus {
    	outline: none;
    }
  }
  #gameCanvasWrapper {
    position: relative;
    display: flex;
    .speed {
      position: absolute;
      right: 10%;
      top: 2%;
      color: #fff;
      z-index: 99999;
			font-size: 15px;

      span {
        margin: 0 15px;
        cursor: pointer;
      }
    }
  }
</style>
